import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BrowserRouter } from 'react-router-dom';
import * as Common from '_common';
import { AppScreen } from './app/AppScreen';
import { SettingsDialog } from './app/SettingDialog';
import { Overlay } from './app/Overlay';
import { LoadingPage } from './app/LoadingPage';
function App() {
    return (_jsx(Common.AppStateManager, { renderLoadingScreen: (loadingState) => (_jsx(LoadingPage, { loadingState: loadingState })), children: _jsxs(BrowserRouter, { children: [_jsx(SettingsDialog, {}), _jsx(Overlay, {}), _jsx(AppScreen, {})] }) }));
}
export default App;
